/**
 * CryptidZoo - Application Entry Point
 */

import { Game } from "./game/Game";

// Wait for DOM to be ready
window.addEventListener("DOMContentLoaded", async () => {
    // Get canvas element
    const canvas = document.getElementById("gameCanvas") as HTMLCanvasElement;
    
    if (!canvas) {
        console.error("Could not find canvas element with id 'gameCanvas'");
        return;
    }

    // Create and start game
    const game = new Game(canvas);
    
    try {
        await game.start();
        console.log("CryptidZoo started successfully!");
    } catch (error) {
        console.error("Failed to start CryptidZoo:", error);
    }

    // Handle cleanup on page unload
    window.addEventListener("beforeunload", () => {
        game.dispose();
    });
});
